var _ellipse, _path, _ellipse2, _ellipse3, _rect, _path2, _ellipse4, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoundComplies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 48,
    viewBox: "0 0 50 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6781,
    cy: 21.0811,
    rx: 20.6781,
    ry: 21.0811,
    fill: "#FFB700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4529 26.9189C11.4529 36.4122 29.3541 38.2702 20.0423 38.2702C10.7304 38.2702 3.18164 30.5744 3.18164 21.081C3.18164 11.5877 10.7304 3.89185 20.0423 3.89185C29.3541 3.89185 11.4529 11.3513 11.4529 26.9189Z",
    fill: "#FCC740"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.7228,
    cy: 21.4055,
    rx: 5.09,
    ry: 5.18919,
    fill: "#FCC740"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.7242,
    cy: 21.4054,
    rx: 3.18125,
    ry: 3.24324,
    fill: "#FFA621"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.08984,
    y: 43.4595,
    width: 31.8125,
    height: 4.54054,
    rx: 2,
    fill: "#FFA621"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9941 46.0541C37.0089 45.8379 43.2654 44.5622 44.5379 41.1892C45.8104 37.8163 45.9164 32.2163 45.8104 29.8379",
    stroke: "#FFA621",
    strokeWidth: 3
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 45.8097,
    cy: 29.1893,
    rx: 3.8175,
    ry: 3.89189,
    fill: "#FFB700"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3971 31.0057C47.5122 32.3417 45.7325 32.6935 44.422 31.7913C43.1116 30.8892 45.225 31.1586 46.1099 29.8226C46.9948 28.4866 46.3161 26.051 47.6265 26.9532C48.937 27.8553 49.282 29.6697 48.3971 31.0057Z",
    fill: "#FFA621"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.571 27.5617C44.2095 26.6754 45.4169 26.4555 45.9232 26.8355C46.2182 27.057 45.7373 27.5447 45.0987 28.4311C44.4602 29.3174 44.0486 29.9329 43.7532 29.7118C43.3186 29.3863 42.9325 28.448 43.571 27.5617Z",
    fill: "#FCC740"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundComplies);
export default __webpack_public_path__ + "static/media/round-complies.4ddbbc0e0584beace7abfd3d9f8f5615.svg";
export { ForwardRef as ReactComponent };